if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);

        var _self = this;
        var _isQuickAdd = !!this.closest('quick-add-modal');

        if (_isQuickAdd) return _self._submitWithSections(evt);

        // ===== FIX ANTI-ABUSO CADEAUX =====
        // Si el producto pertenece a cadeaux-offerts y el cart subtotal_no_gifts < €150,
        // bloquear el ATC con mensaje. Sin esto, el cliente puede ir a la PDP de un cadeau y
        // recibirlo gratis vía descuento auto (sin haber alcanzado threshold de gasto).
        var _giftIds = Array.from(document.querySelectorAll('.cgb-gifts__item[data-cgb-gift-product-id]'))
          .map(function(el){ return parseInt(el.getAttribute('data-cgb-gift-product-id'), 10); })
          .filter(Boolean);
        var _productIdRaw = (this.dataset && this.dataset.productId)
          || (this.querySelector('[name="product-id"]') && this.querySelector('[name="product-id"]').value)
          || (window.product && window.product.id)
          || 0;
        var _productId = parseInt(_productIdRaw, 10) || 0;
        var _giftCheckBypass = (_self.dataset.cgbGiftCheckPassed === '1');
        if (_giftCheckBypass) delete _self.dataset.cgbGiftCheckPassed;
        if (!_giftCheckBypass && _productId && _giftIds.indexOf(_productId) !== -1) {
          // Resetear botón y hacer chequeo async — luego re-emitir submit si pasa.
          _self.submitButton.removeAttribute('aria-disabled');
          _self.submitButton.classList.remove('cd-loading');
          var _origTxt = (_self.submitButtonText.textContent || '').trim();
          if (_origTxt === 'Ajout...') {
            _self.submitButtonText.textContent = 'Vérification...';
          }
          fetch('/cart.js', {credentials:'same-origin', cache:'no-store'})
            .then(function(r){ return r.json(); })
            .then(function(cart){
              var subtotalNoGifts = (cart.items||[]).reduce(function(sum, it){
                return _giftIds.indexOf(it.product_id) !== -1 ? sum : sum + (it.final_line_price||0);
              }, 0);
              var unlocked = (window.cgbCalcUnlocked) ? window.cgbCalcUnlocked(subtotalNoGifts) : (subtotalNoGifts>=15000?1:0);
              var giftDistinct = {};
              (cart.items||[]).forEach(function(it){ if(_giftIds.indexOf(it.product_id)!==-1) giftDistinct[it.product_id]=true; });
              var distinctChosen = Object.keys(giftDistinct).length;
              var alreadyHasIt = !!giftDistinct[_productId];
              var msg = null;
              if (unlocked < 1) {
                var euroNeed = Math.ceil((15000 - subtotalNoGifts) / 100);
                msg = 'Ce produit est offert dès 150€ d’achat. Encore ' + euroNeed + '€ pour le débloquer 🎁';
              } else if (!alreadyHasIt && distinctChosen >= unlocked) {
                msg = 'Vous avez déj�� sélectionné le maximum de cadeaux pour votre panier actuel.';
              } else if (alreadyHasIt) {
                msg = 'Ce cadeau est déjà dans votre panier.';
              }
              if (msg) {
                _self.handleErrorMessage(msg);
                _self.submitButtonText.textContent = 'Añadir a la cesta';
                return;
              }
              // OK: re-disparar el submit con flag para saltar este check
              _self.dataset.cgbGiftCheckPassed = '1';
              _self.submitButtonText.textContent = 'Ajout...';
              if (_self.form.requestSubmit) _self.form.requestSubmit(_self.submitButton);
              else _self.submitButton.click();
            })
            .catch(function(){
              // Failsafe: si /cart.js falla, dejar pasar el ATC normal (no bloquear venta por network)
              _self.dataset.cgbGiftCheckPassed = '1';
              if (_self.form.requestSubmit) _self.form.requestSubmit(_self.submitButton);
              else _self.submitButton.click();
            });
          return;
        }
        // ===== /FIX ANTI-ABUSO =====

        // ===== FLUJO INSTANTÁNEO: open-first + sections-in-POST =====
        // 1) Inyectar fila optimista (mismo helper que sticky usa) + abrir drawer YA (~0ms)
        // 2) POST /cart/add.js con sections en paralelo (~600-800ms)
        // 3) Cuando responda, swap HTML del drawer (la fila optimista es reemplazada por la real)
        // El usuario ve el drawer slide-in instantáneo con la fila ya dentro.
        var _cd = document.querySelector('cart-drawer');
        var _cartWasEmpty = _cd ? _cd.classList.contains('is-empty') : true;

        var _origText = (_self.submitButtonText.textContent || '').trim();
        if (_origText && _origText !== '¡Añadido!' && _origText !== 'Ajout...') {
          _self.submitButtonText.textContent = 'Ajout...';
        }
        _self.submitButton.classList.add('cd-loading');

        var formData = new FormData(_self.form);
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        if (_self.cart && _self.cart.setActiveElement) _self.cart.setActiveElement(document.activeElement);

        // NO optimistic open — esperamos respuesta del server antes de abrir drawer
        // para evitar el "parón" donde se ven duplicados que luego se mergean.
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: formData
        })
        .then(function(r){ return r.json().then(function(j){ return {status: r.status, body: j}; }); })
        .then(function(res){
          if (res.status >= 400) {
            // No cleanup needed: drawer no fue abierto optimistamente
            _self.submitButtonText.textContent = _origText || 'Añadir a la cesta';
            _self.submitButton.classList.remove('cd-loading');
            try {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: res.body.errors || res.body.description,
                message: res.body.message,
              });
            } catch(e){}
            _self.handleErrorMessage(res.body.description || res.body.message);
            var soldOutMessage = _self.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              _self.submitButton.setAttribute('aria-disabled', true);
              _self.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              _self.error = true;
            }
            return;
          }
          _self.error = false;

          // Tracking — CRÍTICO para Meta Pixel AddToCart
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: res.body,
            });
          } catch(e) { console.warn('publish cartUpdate failed', e); }

          // Swap del HTML del drawer ANTES de abrirlo — server-side merge de duplicados ya hecho
          var sections = res.body.sections || {};
          if (sections['cart-drawer'] && _cd) {
            try {
              var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
              var newCD = doc.querySelector('cart-drawer');
              if (newCD) {
                _cd.classList.add('cd-skip-anim');
                _cd.innerHTML = newCD.innerHTML;
                _cd.classList.remove('is-empty');
                var ov = _cd.querySelector('#CartDrawer-Overlay');
                if (ov && _cd.close) ov.addEventListener('click', function(){ try{ _cd.close(); }catch(e){} });
              }
            } catch(e) { console.warn('drawer inject failed', e); }
          }
          if (sections['cart-icon-bubble']) {
            var ib = document.getElementById('cart-icon-bubble');
            if (ib) {
              try {
                var bDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                var ni = bDoc.querySelector('.shopify-section');
                if (ni) ib.innerHTML = ni.innerHTML;
              } catch(e) { console.warn('bubble inject failed', e); }
            }
          }

          // AHORA abrimos el drawer — ya tiene el estado correcto (sin duplicados visibles)
          if (_cd) {
            try { _cd.open(_self.submitButton); } catch(e){}
          }

          // FIX PARÓN: actualizar gift bar/carousel UNA SOLA vez con fetch /cart.js
          // (antes lo disparaba un MutationObserver al detectar .cgb-gifts en el swap,
          // y CartItems.onCartUpdate hacía un 2º swap completo — ambos eliminados)
          try {
            fetch('/cart.js', {credentials:'same-origin', cache:'no-store'})
              .then(function(r){ return r.json(); })
              .then(function(cart){
                if (window.cgbUpdateAvailability) window.cgbUpdateAvailability(cart);
              })
              .catch(function(){});
          } catch(e){}

          _self.submitButtonText.textContent = _origText || 'Añadir a la cesta';
          _self.submitButton.classList.remove('cd-loading');
          window.__cdFeedbackAdded(_self);
        })
        .catch(function(e){
          console.error('ATC error', e);
          _self.submitButtonText.textContent = _origText || 'Añadir a la cesta';
          _self.submitButton.classList.remove('cd-loading');
        })
        .finally(function(){
          if (!_self.error) _self.submitButton.removeAttribute('aria-disabled');
          try { CartPerformance.measureFromEvent("add:user-action", evt); } catch(e){}
        });
      }

      // QuickAdd modal — preserva flujo original Dawn
      _submitWithSections(evt) {
        var _self = this;
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map(function(s){return s.id;}).join(','));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(routes.cart_add_url, config)
          .then(function(r){ return r.json(); })
          .then(function(response){
            if (response.status) {
              try { publish(PUB_SUB_EVENTS.cartError, {source:'product-form', productVariantId: formData.get('id'), errors: response.errors||response.description, message: response.message}); } catch(e){}
              _self.handleErrorMessage(response.description);
              return;
            }
            try { publish(PUB_SUB_EVENTS.cartUpdate, {source:'product-form', productVariantId: formData.get('id'), cartData: response}); } catch(e){}
            document.body.addEventListener('modalClosed', function(){
              setTimeout(function(){ if (response.sections && _self.cart) _self.cart.renderContents(response); });
            }, {once:true});
          })
          .catch(function(e){ console.error(e); })
          .finally(function(){ _self.submitButton.removeAttribute('aria-disabled'); });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* ============================================
   HELPERS optimistic ATC (compartidos por product-form y sticky)
   ============================================ */
window.__cdInjectOptimisticRow = function(cd, form, wasEmpty) {
  // Lee datos del PDP DOM y construye un <tr class="cart-item"> visualmente IDÉNTICO al real
  var productInfo = document.querySelector('product-info, .product');
  // SOLO h1 (entry pdp-title-h1-only): .product__title envuelve h1 y h2 enlace
  var h1 = productInfo ? productInfo.querySelector('.product__title h1, h1.product__title, h1') : null;
  var title = h1 ? h1.textContent.trim() : '';

  var imgEl = productInfo ? productInfo.querySelector('.product__media-item.is-active img, .product__media img') : null;
  var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

  // Variante (sólo el SELECTED pill/swatch del primer fieldset, no concatenar todos)
  var variantTitle = '';
  if (productInfo) {
    var parts = [];
    productInfo.querySelectorAll('fieldset.product-form__input').forEach(function(fs){
      var input = fs.querySelector('input[type=radio]:checked');
      if (input) parts.push(input.value);
      else {
        var sel = fs.querySelector('select');
        if (sel && sel.options[sel.selectedIndex]) parts.push(sel.options[sel.selectedIndex].text);
      }
    });
    variantTitle = parts.filter(Boolean).join(' / ');
  }

  // Precios: si hay .price__sale (con descuento), compare = strikethrough s.price-item--regular
  // Si NO hay descuento, sólo .price__regular .price-item--regular
  var saleBlock = productInfo ? productInfo.querySelector('.price__sale') : null;
  var compareEl, saleEl;
  if (saleBlock) {
    compareEl = saleBlock.querySelector('s.price-item--regular, .price-item--regular') ||
                productInfo.querySelector('.price__sale s.price-item--regular');
    saleEl = saleBlock.querySelector('.price-item--sale, .price-item--last');
  } else {
    saleEl = productInfo ? productInfo.querySelector('.price__regular .price-item--regular, .price-item') : null;
    compareEl = null;
  }
  var compareTxt = compareEl ? compareEl.textContent.trim() : '';
  var saleTxt = saleEl ? saleEl.textContent.trim() : '';
  var hasDiscount = compareTxt && saleTxt && compareTxt !== saleTxt;

  function parseEuroCents(s) {
    if (!s) return 0;
    var m = s.replace(/\s/g,'').match(/([0-9]+)[,\.]?([0-9]{0,2})/);
    if (!m) return 0;
    return parseInt(m[1],10)*100 + (m[2] ? parseInt(m[2].padEnd(2,'0'),10) : 0);
  }
  function fmtEuro(cents) {
    var c = window.WAB_CURRENCY || {};
    var s = (cents/100).toFixed(2);
    if (c.useComma) s = s.replace('.', ',');
    if (c.prefix || c.suffix) return (c.prefix || '') + s + (c.suffix || '');
    return '$ ' + s;
  }
  var compareCents = parseEuroCents(compareTxt);
  var saleCents = parseEuroCents(saleTxt);
  var savingsCents = hasDiscount ? (compareCents - saleCents) : 0;

  var qty = +(form && form.querySelector('[name=quantity]') && form.querySelector('[name=quantity]').value) || 1;
  var lineSaleCents = saleCents * qty;
  var lineCompareCents = compareCents * qty;
  var lineSavingsCents = savingsCents * qty;

  // ===== FIX PARÓN 2 FILAS: smart-merge si el variant ya está en el cart =====
  // Antes: siempre añadíamos una NUEVA fila optimista (con id CartDrawer-Item-OPT). Si el
  // variant ya estaba en cart con qty=N, el drawer mostraba N+1 filas (existing qty=N + opt qty=1)
  // y al llegar el server-render se consolidaba en 1 fila qty=N+1. Eso es la "recarga" que ve
  // el usuario. Ahora detectamos si ya existe la fila e incrementamos su qty + line prices,
  // marcándola con data-cd-optimistic-merged="qtyOriginal" para revertir si la operación falla.
  var variantIdRaw = form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
  var variantId = parseInt(variantIdRaw, 10) || 0;
  var existingInput = variantId ? cd.querySelector('cart-drawer-items input[data-quantity-variant-id="' + variantId + '"]') : null;
  var existingRow = existingInput ? existingInput.closest('tr.cart-item') : null;
  if (existingRow && !existingRow.dataset.cdOptimistic) {
    var prevQty = parseInt(existingInput.value || existingInput.getAttribute('data-cart-quantity') || '0', 10) || 0;
    var newQty = prevQty + qty;
    // Mark for rollback
    existingRow.dataset.cdOptimisticMerged = String(prevQty);
    existingInput.value = String(newQty);
    existingInput.setAttribute('data-cart-quantity', String(newQty));
    // Update qty wrapper data-item-qty si existe (en main wrapper data-line)
    var qtyWrapper = existingRow.querySelector('[data-item-qty]');
    if (qtyWrapper) qtyWrapper.setAttribute('data-item-qty', String(newQty));
    // Recalcular precios de la línea (price * newQty)
    var newLineSale = saleCents * newQty;
    var newLineCompare = compareCents * newQty;
    var newLineSavings = savingsCents * newQty;
    // Buscar y actualizar el bloque de precios de la fila
    var rowPriceEl = existingRow.querySelector('.cgb-line-price__current');
    if (rowPriceEl) rowPriceEl.textContent = fmtEuro(newLineSale);
    var rowCompareEl = existingRow.querySelector('.cgb-line-price__compare');
    if (rowCompareEl) rowCompareEl.textContent = fmtEuro(newLineCompare);
    var rowBadgeEl = existingRow.querySelector('.cgb-line-badge span');
    if (rowBadgeEl && hasDiscount) rowBadgeEl.textContent = 'DESCUENTOS PROGRESIVOS (-' + fmtEuro(newLineSavings) + ')';
    // Update heading + subtotal + económisez + bubble (mismo código que abajo, factorizado)
    try {
      var heading_m = cd.querySelector('.drawer__heading');
      var headingLabel_m = cd.querySelector('.drawer__heading-label');
      var existingCount_m = 0;
      if (headingLabel_m) {
        var hm_m = (headingLabel_m.textContent || '').match(/(\d+)/);
        if (hm_m) existingCount_m = parseInt(hm_m[1], 10) || 0;
      }
      var newCount_m = existingCount_m + qty;
      if (headingLabel_m) headingLabel_m.textContent = newCount_m === 1 ? '1 artículo' : (newCount_m + ' artículos');
      var subtotalEl_m = cd.querySelector('.drawer-total-price');
      var curCartCents_m = subtotalEl_m ? parseEuroCents(subtotalEl_m.textContent || '') : 0;
      var newCartCents_m = curCartCents_m + lineSaleCents;
      if (typeof window.__cgbUpdateBar === 'function') window.__cgbUpdateBar(cd, newCartCents_m);
      if (subtotalEl_m) subtotalEl_m.textContent = fmtEuro(newCartCents_m);
      if (lineSavingsCents > 0) {
        var ecoRow_m = cd.querySelector('.drawer-economisez-row');
        if (ecoRow_m) {
          ecoRow_m.style.display = '';
          var ecoAmt_m = ecoRow_m.querySelector('.drawer-discount-amount');
          if (ecoAmt_m) {
            var curEco_m = parseEuroCents((ecoAmt_m.textContent || '').replace('-', ''));
            ecoAmt_m.textContent = '-' + fmtEuro(curEco_m + lineSavingsCents);
          }
        }
      }
      var checkoutBtn_m = cd.querySelector('#CartDrawer-Checkout, button[name="checkout"]');
      if (checkoutBtn_m) checkoutBtn_m.disabled = false;
      var bubble_m = document.getElementById('cart-icon-bubble');
      if (bubble_m) {
        var existingBubble_m = bubble_m.querySelector('.cart-count-bubble');
        if (existingBubble_m) {
          var visSpan_m = existingBubble_m.querySelector('span[aria-hidden="true"]');
          if (visSpan_m) visSpan_m.textContent = newCount_m;
        }
      }
    } catch(e) { console.warn('optim merge updates', e); }
    return existingRow;
  }
  // ===== /FIX PARÓN 2 FILAS =====


  // NEW layout pricing block (matches Liquid template — sin parpadeo)
  var pricesHtml = hasDiscount
    ? '<div class="cgb-line-price">' +
        '<span class="cgb-line-price__current">' + fmtEuro(lineSaleCents) + '</span>' +
        '<s class="cgb-line-price__compare">' + fmtEuro(lineCompareCents) + '</s>' +
      '</div>' +
      '<div class="cgb-line-badge">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
        '<span>PRIX DÉGRESSIFS (-' + fmtEuro(lineSavingsCents) + ')</span>' +
      '</div>'
    : '<div class="cgb-line-price"><span class="cgb-line-price__current cgb-line-price__current--plain">' + fmtEuro(lineSaleCents) + '</span></div>';

  // Variant split: si tiene "X / Y", split into color + size; si solo uno, mostrar como size con chevron
  var variantHtml = '';
  if (variantTitle) {
    var vparts = variantTitle.split(' / ');
    if (vparts.length >= 2) {
      variantHtml =
        '<div class="cart-variant-toggle cart-variant-toggle--vertical">' +
          '<div class="cart-variant-toggle__color">' + vparts[0].toUpperCase() + '</div>' +
          '<div class="cart-variant-toggle__row cart-variant-toggle__row--main">' +
            '<span class="cart-variant-toggle__size">' + vparts[1] + '</span>' +
            '<svg class="cart-variant-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>' +
          '</div>' +
        '</div>';
    } else {
      variantHtml =
        '<div class="cart-variant-toggle cart-variant-toggle--vertical">' +
          '<div class="cart-variant-toggle__row cart-variant-toggle__row--main cart-variant-toggle__row--solo">' +
            '<span class="cart-variant-toggle__size cart-variant-toggle__size--solo">' + vparts[0] + '</span>' +
            '<svg class="cart-variant-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>' +
          '</div>' +
        '</div>';
    }
  }

  var tr = document.createElement('tr');
  tr.id = 'CartDrawer-Item-OPT';
  tr.className = 'cart-item';
  tr.setAttribute('role', 'row');
  tr.setAttribute('data-cd-optimistic', '1');
  tr.innerHTML =
    '<td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">' +
      '<a href="#" class="cart-item__link" tabindex="-1" aria-hidden="true" onclick="return false;"></a>' +
      (imgSrc ? '<img class="cart-item__image" src="' + imgSrc + '" alt="" loading="eager">' : '') +
    '</td>' +
    '<td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">' +
      '<a href="#" class="cart-item__name" onclick="return false;">' + title + '</a>' +
      variantHtml +
      pricesHtml +
    '</td>' +
    '<td class="cart-item__totals right cgb-totals-hidden" role="cell" headers="CartDrawer-ColumnTotal" style="display:none!important"></td>' +
    '<td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">' +
      '<div class="cart-item__quantity-wrapper quantity-popover-wrapper">' +
        '<div class="quantity-popover-container">' +
          '<div class="quantity cart-quantity" style="display:flex;align-items:center;">' +
            '<button class="quantity__button" name="minus" type="button" disabled style="opacity:.5;">−</button>' +
            '<input class="quantity__input" type="number" value="' + qty + '" readonly>' +
            '<button class="quantity__button" name="plus" type="button" disabled style="opacity:.5;">+</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</td>';

  // Buscar tbody existente para insertar el row
  var tbody = cd.querySelector('table.cart-items tbody');
  if (tbody) {
    tbody.appendChild(tr);
    return tr;
  }

  // Cart vacío: ocultar empty state, quitar is-empty de cart-drawer-items
  // (el CSS del tema oculta el footer cuando cart-drawer-items.is-empty)
  var emptyEl = cd.querySelector('.drawer__inner-empty');
  if (emptyEl) emptyEl.style.display = 'none';
  var cdItems = cd.querySelector('cart-drawer-items');
  if (cdItems) {
    cdItems.classList.remove('is-empty');
    cdItems.setAttribute('data-cd-was-empty', '1');
  }

  // Insertar la table dentro de #CartDrawer-CartItems con estructura completa (thead + tbody)
  var cartItemsContainer = cd.querySelector('#CartDrawer-CartItems');
  var wrap = document.createElement('div');
  wrap.className = 'drawer__cart-items-wrapper cd-optimistic-wrap';
  wrap.setAttribute('data-cd-optimistic-wrap', '1');
  wrap.innerHTML =
    '<table class="cart-items" role="table">' +
      '<thead role="rowgroup">' +
        '<tr role="row">' +
          '<th id="CartDrawer-ColumnProductImage" role="columnheader"><span class="visually-hidden">Imagen del producto</span></th>' +
          '<th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">Producto</th>' +
          '<th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">Total</th>' +
          '<th id="CartDrawer-ColumnQuantity" role="columnheader"><span class="visually-hidden">Cantidad</span></th>' +
        '</tr>' +
      '</thead>' +
      '<tbody role="rowgroup"></tbody>' +
    '</table>';
  wrap.querySelector('tbody').appendChild(tr);

  if (cartItemsContainer) {
    // Insertar ANTES de .cgb-gifts si existe (mantener orden item→cadeaux)
    var recoBlock = cartItemsContainer.querySelector('.cgb-gifts, .drawer-recommendations');
    if (recoBlock) cartItemsContainer.insertBefore(wrap, recoBlock);
    else cartItemsContainer.appendChild(wrap);
  } else {
    var footer = cd.querySelector('.drawer__footer');
    var contents = cd.querySelector('.drawer__inner');
    if (footer && footer.parentNode) footer.parentNode.insertBefore(wrap, footer);
    else if (contents) contents.appendChild(wrap);
  }

  // Update inmediato heading + subtotal + económisez + bubble + checkout
  // + UNHIDE progress bar y reco section (siempre en DOM, hidden cuando vacío)
  try {
    var heading = cd.querySelector('.drawer__heading');
    var headingLabel = cd.querySelector('.drawer__heading-label');
    var existingCount = 0;
    if (headingLabel) {
      var hm = (headingLabel.textContent || '').match(/(\d+)/);
      if (hm) existingCount = parseInt(hm[1],10) || 0;
    } else if (heading) {
      var hm2 = (heading.textContent || '').match(/·\s*(\d+)/);
      if (hm2) existingCount = parseInt(hm2[1],10) || 0;
    }
    var newCount = existingCount + qty;
    if (headingLabel) {
      headingLabel.textContent = newCount === 1 ? '1 article' : (newCount + ' articles');
    } else if (heading) {
      heading.textContent = ((heading.textContent || '').split('·')[0] || 'Tu cesta ').trim() + ' · ' + newCount;
    }

    // Ocultar empty state si visible
    var emptyEl = cd.querySelector('.drawer__inner-empty');
    if (emptyEl) emptyEl.style.display = 'none';

    // Cart Gift Bar: actualizar fill + mensaje + iconos según total optimista
    var subtotalEl = cd.querySelector('.drawer-total-price');
    var curCartCents = subtotalEl ? parseEuroCents(subtotalEl.textContent || '') : 0;
    var newCartCents = curCartCents + lineSaleCents;
    if (typeof window.__cgbUpdateBar === 'function') window.__cgbUpdateBar(cd, newCartCents);

    // Gift carrusel: unhide
    var giftEl = cd.querySelector('.cgb-gifts');
    if (giftEl) giftEl.style.display = '';

    // Subtotal
    var subtotal = cd.querySelector('.drawer-total-price');
    if (subtotal) {
      var curCents = parseEuroCents(subtotal.textContent || '');
      subtotal.textContent = fmtEuro(curCents + lineSaleCents);
    }
    // Économisez row (compare_at_savings): unhide + sumar
    if (lineSavingsCents > 0) {
      var ecoRow = cd.querySelector('.drawer-economisez-row');
      if (ecoRow) {
        ecoRow.style.display = '';
        var ecoAmt = ecoRow.querySelector('.drawer-discount-amount');
        if (ecoAmt) {
          var curEco = parseEuroCents((ecoAmt.textContent || '').replace('-',''));
          ecoAmt.textContent = '-' + fmtEuro(curEco + lineSavingsCents);
        }
      }
    }

    // Checkout enable
    var checkoutBtn = cd.querySelector('#CartDrawer-Checkout, button[name="checkout"]');
    if (checkoutBtn) checkoutBtn.disabled = false;

    // Bubble
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      var bubCount = newCount;
      var existingBubble = bubble.querySelector('.cart-count-bubble');
      if (existingBubble) {
        var visSpan = existingBubble.querySelector('span[aria-hidden="true"]');
        if (visSpan) visSpan.textContent = bubCount;
      } else {
        var newB = document.createElement('div');
        newB.className = 'cart-count-bubble';
        newB.innerHTML = '<span aria-hidden="true">' + bubCount + '</span><span class="visually-hidden">' + bubCount + '&nbsp;article' + (bubCount>1?'s':'') + '</span>';
        bubble.appendChild(newB);
      }
    }
  } catch(e) { console.warn('optimistic preUpdate failed', e); }

  return tr;
};

window.__cdRemoveOptimistic = function(cd) {
  if (!cd) return;
  // (a) Eliminar filas/wraps optimistas (caso variant nuevo o cart vacío)
  cd.querySelectorAll('[data-cd-optimistic="1"], [data-cd-optimistic-wrap="1"]').forEach(function(el){
    el.parentNode && el.parentNode.removeChild(el);
  });
  // (b) Revertir merges optimistas (caso variant ya existía y solo incrementamos qty)
  cd.querySelectorAll('[data-cd-optimistic-merged]').forEach(function(row){
    var origQty = parseInt(row.dataset.cdOptimisticMerged || '0', 10) || 0;
    delete row.dataset.cdOptimisticMerged;
    var input = row.querySelector('input.quantity__input');
    if (input) { input.value = String(origQty); input.setAttribute('data-cart-quantity', String(origQty)); }
    var qtyWrapper = row.querySelector('[data-item-qty]');
    if (qtyWrapper) qtyWrapper.setAttribute('data-item-qty', String(origQty));
    // Nota: no recalculamos los precios de la línea aquí — el siguiente swap del HTML server
    // (que ocurre tras el error) restaurará todo el row con valores reales del cart server.
  });
  // (c) Restaurar empty state si lo habíamos ocultado al inyectar
  var emptyEl = cd.querySelector('.drawer__inner-empty');
  if (emptyEl) emptyEl.style.display = '';
  var cdItems = cd.querySelector('cart-drawer-items[data-cd-was-empty="1"]');
  if (cdItems) {
    cdItems.classList.add('is-empty');
    cdItems.removeAttribute('data-cd-was-empty');
  }
};

// Cart Gift Bar update — recalcula fill, mensaje, iconos según total en cents
window.__cgbUpdateBar = function(cd, cartCents) {
  if (!cd) return;
  var bar = cd.querySelector('.cgb-bar');
  if (!bar) return;
  var t1 = 12000, t2 = 15000, t3 = 20000, t4 = 25000;
  var fill, msg, unlocked;
  // Milestones at 12.5/37.5/62.5/87.5% — fill llega al CENTRO del icon, no al final del segmento
  if (cartCents >= t4) {
    fill = 100;
    msg = 'Youpi, vous bénéficiez de toutes les offres !';
    unlocked = 3;
  } else if (cartCents >= t3) {
    fill = 67 + Math.round((cartCents - t3) / (t4 - t3) * 25);
    msg = 'Solo ' + Math.ceil((t4 - cartCents)/100) + '€ más para tu 3er regalo';
    unlocked = 2;
  } else if (cartCents >= t2) {
    fill = 42 + Math.round((cartCents - t2) / (t3 - t2) * 25);
    msg = 'Solo ' + Math.ceil((t3 - cartCents)/100) + '€ más para tu 2º regalo';
    unlocked = 1;
  } else if (cartCents >= t1) {
    fill = 17 + Math.round((cartCents - t1) / (t2 - t1) * 25);
    msg = 'Solo ' + Math.ceil((t2 - cartCents)/100) + '€ más para tu 1er regalo';
    unlocked = 0;
  } else {
    fill = cartCents > 0 ? Math.round(cartCents / t1 * 17) : 0;
    msg = 'Solo ' + Math.ceil((t1 - cartCents)/100) + '€ más para envío gratis';
    unlocked = 0;
  }
  bar.style.display = '';
  bar.setAttribute('data-cgb-fill', fill);
  bar.setAttribute('data-cgb-unlocked', unlocked);
  var msgEl = bar.querySelector('.cgb-bar__msg');
  if (msgEl) msgEl.textContent = msg;
  var fillEl = bar.querySelector('.cgb-bar__fill');
  if (fillEl) fillEl.style.width = fill + '%';
  var icons = bar.querySelectorAll('.cgb-bar__icon');
  if (icons.length === 4) {
    icons[0].classList.toggle('is-unlocked', cartCents >= t1);
    icons[1].classList.toggle('is-unlocked', cartCents >= t2);
    icons[2].classList.toggle('is-unlocked', cartCents >= t3);
    icons[3].classList.toggle('is-unlocked', cartCents >= t4);
  }
  var heading = cd.querySelector('[data-cgb-gifts-heading]');
  if (heading) {
    if (unlocked === 0) heading.textContent = 'Vos cadeaux à débloquer 🎁';
    else if (unlocked === 1) heading.textContent = 'Vous avez encore 1 cadeau à choisir 🎁';
    else heading.textContent = 'Te quedan ' + unlocked + ' regalos por elegir 🎁';
  }
  var giftBlock = cd.querySelector('.cgb-gifts');
  if (giftBlock) giftBlock.style.display = '';
};

window.__cdQuickUpdate = function(cd, cart) {
  if (!cd || !cart) return;
  // Format price respecting active shop currency (WAB_CURRENCY from theme.liquid)
  function fmt(cents) {
    var c = window.WAB_CURRENCY || {};
    var s = (cents/100).toFixed(2);
    if (c.useComma) s = s.replace('.', ',');
    if (c.prefix || c.suffix) return (c.prefix || '') + s + (c.suffix || '');
    return '$ ' + s;
  }
  // Cart Gift Bar — actualizar con total real
  if (typeof window.__cgbUpdateBar === 'function') window.__cgbUpdateBar(cd, cart.total_price);
  // Heading "Panier" / "N articles" — actualizar el span dedicado para preservar icono
  var heading = cd.querySelector('.drawer__heading');
  var headingLabel = cd.querySelector('.drawer__heading-label');
  if (headingLabel) {
    headingLabel.textContent = cart.item_count === 0 ? 'Cesta' : (cart.item_count === 1 ? '1 artículo' : (cart.item_count + ' artículos'));
  } else if (heading) {
    var t = heading.textContent || '';
    if (/·\s*\d+/.test(t)) heading.textContent = t.replace(/·\s*\d+/, '· ' + cart.item_count);
    else heading.textContent = (t.split('·')[0] || 'Tu cesta ').trim() + ' · ' + cart.item_count;
  }
  // Sous-total
  var subtotal = cd.querySelector('.drawer-total-price');
  if (subtotal) subtotal.textContent = fmt(cart.total_price);
  // Économisez row (mostrar solo si hay descuento automático)
  var ecoRow = cd.querySelector('.drawer-economisez-row');
  if (ecoRow) {
    if (cart.total_discount && cart.total_discount > 0) {
      ecoRow.style.display = '';
      var ecoAmount = ecoRow.querySelector('.drawer-discount-amount');
      if (ecoAmount) ecoAmount.textContent = '-' + fmt(cart.total_discount);
    } else {
      ecoRow.style.display = 'none';
    }
  }
  // Botón checkout — habilitarlo
  var checkoutBtn = cd.querySelector('#CartDrawer-Checkout, button[name="checkout"]');
  if (checkoutBtn) checkoutBtn.disabled = false;
  // Cart icon bubble
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble) {
    var countWrap = bubble.querySelector('.cart-count-bubble');
    if (countWrap) {
      var visibleSpan = countWrap.querySelector('span[aria-hidden="true"]');
      if (visibleSpan) visibleSpan.textContent = cart.item_count;
      var srSpan = countWrap.querySelector('.visually-hidden');
      if (srSpan) srSpan.innerHTML = cart.item_count + '&nbsp;article' + (cart.item_count > 1 ? 's' : '');
    } else if (cart.item_count > 0) {
      // No bubble existente: crear uno mínimo
      var bWrap = document.createElement('div');
      bWrap.className = 'cart-count-bubble';
      bWrap.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + '&nbsp;article' + (cart.item_count > 1 ? 's' : '') + '</span>';
      bubble.appendChild(bWrap);
    }
  }
};

window.__cdRefreshDrawerSection = function(cd) {
  if (!cd) return Promise.resolve();
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ts = Date.now();
  return Promise.all([
    fetch(rootUrl + '?section_id=cart-drawer&_ts=' + ts, {credentials:'same-origin', cache:'no-store'}).then(function(r){return r.text();}),
    fetch(rootUrl + '?section_id=cart-icon-bubble&_ts=' + ts, {credentials:'same-origin', cache:'no-store'}).then(function(r){return r.text();}).catch(function(){return null;})
  ]).then(function(results){
    var doc = new DOMParser().parseFromString(results[0], 'text/html');
    var newCD = doc.querySelector('cart-drawer');
    if (newCD && cd) {
      var keepActive = cd.classList.contains('active');
      var keepAnimate = cd.classList.contains('animate');
      // FIX PARÓN v3: cd-skip-anim persiste hasta close(). Ver doSwap() arriba.
      cd.classList.add('cd-skip-anim');
      cd.innerHTML = newCD.innerHTML;
      cd.classList.remove('is-empty');
      if (keepActive) cd.classList.add('active');
      if (keepAnimate) cd.classList.add('animate');
      var ov = cd.querySelector('#CartDrawer-Overlay');
      if (ov && cd.close) ov.addEventListener('click', function(){ try{ cd.close(); }catch(e){} });
    }
    var ib = document.getElementById('cart-icon-bubble');
    if (ib && results[1]) {
      var bDoc = new DOMParser().parseFromString(results[1], 'text/html');
      var ni = bDoc.querySelector('.shopify-section');
      if (ni) ib.innerHTML = ni.innerHTML;
    }
  }).catch(function(e){ console.warn('refreshDrawerSection failed', e); });
};

window.__cdFeedbackAdded = function(self) {
  var rawOriginal = (self.submitButtonText.textContent || '').trim();
  var originalText = (rawOriginal && rawOriginal !== '¡Añadido!') ? rawOriginal : 'Añadir a la cesta';
  var mirrorBtn = document.querySelector('.sticky-mirror-btn');
  var mirrorTxtEl = mirrorBtn ? mirrorBtn.querySelector('.sticky-mirror-btn-text') : null;
  var rawMirror = mirrorTxtEl ? (mirrorTxtEl.textContent || '').trim() : '';
  var mirrorOriginal = (rawMirror && rawMirror !== '¡Añadido!') ? rawMirror : 'AÑADIR A LA CESTA';

  self.submitButtonText.textContent = '¡Añadido!';
  if (mirrorTxtEl) mirrorTxtEl.textContent = '¡Añadido!';
  self.submitButton.classList.add('added');

  var restored = false;
  var restoreText = function() {
    if (restored) return;
    restored = true;
    self.submitButtonText.textContent = originalText;
    if (mirrorTxtEl) mirrorTxtEl.textContent = mirrorOriginal;
    self.submitButton.classList.remove('added');
  };

  var cdEl = document.querySelector('cart-drawer');
  var obs = null;
  if (cdEl) {
    var everActive = cdEl.classList.contains('active');
    obs = new MutationObserver(function(){
      var isActive = cdEl.classList.contains('active');
      if (isActive) everActive = true;
      if (everActive && !isActive) {
        restoreText();
        obs.disconnect();
      }
    });
    obs.observe(cdEl, {attributes:true, attributeFilter:['class']});
  }
  setTimeout(function(){ if (obs) obs.disconnect(); restoreText(); }, 8000);
};

// Compat — algunos onclick antiguos pueden seguir llamándolo
function triggerMirrorClick() {
  var btn = document.getElementById('sticky-atc-btn');
  if (btn) { btn.click(); return; }
  var fallback = document.querySelector('.product-form__submit');
  if (fallback) fallback.click();
}

document.addEventListener('DOMContentLoaded', function() {
  // Dispara el check inicial: si ATC está fuera de viewport, mostrar sticky de inmediato
  window.dispatchEvent(new Event('scroll'));
});
window.addEventListener('scroll', function() {
  const laBarraDeAbajo = document.getElementById('sticky-identical-wrapper');
  const elBotonDeArriba = document.querySelector('.product-form__submit');

  if (elBotonDeArriba && laBarraDeAbajo) {
    const botonRect = elBotonDeArriba.getBoundingClientRect();
    // Mostrar sticky cuando ATC no está visible: pasado arriba O aún no llegamos
    const fueraArriba = botonRect.bottom < 0;
    const fueraAbajo = botonRect.top > window.innerHeight;
    if (fueraArriba || fueraAbajo) {
      laBarraDeAbajo.classList.add('is-active');
    } else {
      laBarraDeAbajo.classList.remove('is-active');
    }
  }
});

/* ============================================
   STICKY ATC — POST directo + bottom-sheet variantes
   ============================================ */
(function() {
  function refreshDrawerInBackground() {
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var ts = Date.now();
    return Promise.all([
      fetch(rootUrl + '?section_id=cart-drawer&_ts=' + ts, {credentials:'same-origin', cache:'no-store'}).then(function(r){return r.text();}),
      fetch(rootUrl + '?section_id=cart-icon-bubble&_ts=' + ts, {credentials:'same-origin', cache:'no-store'}).then(function(r){return r.text();})
    ]).then(function(results) {
      var dd = new DOMParser().parseFromString(results[0], 'text/html');
      var nd = dd.querySelector('cart-drawer');
      var cd = document.querySelector('cart-drawer');
      if (nd && cd) {
        // FIX PARÓN v3: cd-skip-anim persiste hasta close(). Ver doSwap() arriba.
        cd.classList.add('cd-skip-anim');
        cd.innerHTML = nd.innerHTML;
        cd.classList.remove('is-empty');
        cd.classList.add('animate', 'active');
        var ov = cd.querySelector('#CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', function() { cd.close(); });
      }
      var ib = document.getElementById('cart-icon-bubble');
      if (ib && results[1]) {
        var id2 = new DOMParser().parseFromString(results[1], 'text/html');
        var ni = id2.querySelector('.shopify-section');
        if (ni) ib.innerHTML = ni.innerHTML;
      }
    }).catch(function(e){ console.warn('refreshDrawer failed', e); });
  }

  function getCurrentVariantId() {
    var btn = document.getElementById('sticky-atc-btn');
    if (btn && btn.getAttribute('data-variant-id')) return btn.getAttribute('data-variant-id');
    var formInput = document.querySelector('product-info form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
    return formInput ? formInput.value : null;
  }

  function syncStickyFromForm() {
    var input = document.querySelector('product-info form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
    if (!input) return;
    var btn = document.getElementById('sticky-atc-btn');
    var buyNow = document.getElementById('sticky-buynow-btn');
    if (btn) btn.setAttribute('data-variant-id', input.value);
    if (buyNow) buyNow.setAttribute('data-variant-id', input.value);

    var sheet = document.getElementById('sticky-variant-sheet');
    var label = document.getElementById('sticky-variant-label');

    var matchedTitle = null;
    if (sheet && input.value) {
      sheet.querySelectorAll('.sticky-variant-option').forEach(function(opt){
        var sel = opt.getAttribute('data-variant-id') === String(input.value);
        opt.classList.toggle('is-selected', sel);
        opt.setAttribute('aria-selected', sel ? 'true' : 'false');
        if (sel) matchedTitle = opt.getAttribute('data-variant-title');
      });
    }
    if (label && matchedTitle) label.textContent = matchedTitle;

    var atc = document.getElementById('sticky-atc-btn');
    if (atc) {
      var formBtn = document.querySelector('product-info .product-form__submit, .product-form__submit');
      var disabled = formBtn && (formBtn.getAttribute('aria-disabled') === 'true' || formBtn.disabled);
      var txt = atc.querySelector('.sticky-mirror-btn-text');
      if (disabled) {
        atc.setAttribute('data-soldout', 'true');
        if (txt) txt.textContent = 'AGOTADO';
        // NO tocar buyNow — el sheet maneja la selección de variant internamente
      } else {
        atc.removeAttribute('data-soldout');
        if (txt && txt.textContent === 'AGOTADO') txt.textContent = 'AÑADIR';
        if (buyNow) buyNow.removeAttribute('data-soldout');
      }
    }
  }

  function stickyAddToCart() {
    var btn = document.getElementById('sticky-atc-btn');
    if (!btn || btn.getAttribute('data-soldout') === 'true' || btn.classList.contains('is-loading')) return;
    var variantId = getCurrentVariantId();
    if (!variantId) return;

    btn.classList.add('is-loading');
    var txt = btn.querySelector('.sticky-mirror-btn-text');
    var originalText = txt ? txt.textContent : '';
    if (txt) txt.textContent = 'Ajout...';

    closeSheet();

    var cd = document.querySelector('cart-drawer');

    // NO optimistic open — esperamos respuesta del server antes de abrir drawer
    // POST con sections=cart-drawer para recibir HTML renderizado en la misma respuesta
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: formData
    })
    .then(function(r){ return r.json().then(function(j){ return {status: r.status, body: j}; }); })
    .then(function(res){
      if (res.status >= 400) {
        if (txt) txt.textContent = (res.body && res.body.description) || 'Error';
        setTimeout(function(){ if (txt) txt.textContent = originalText; }, 2500);
        return;
      }

      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sticky-add-to-cart',
            productVariantId: variantId,
            cartData: res.body
          });
        }
      } catch(e) { console.warn('sticky ATC publish failed', e); }

      // Swap HTML del drawer ANTES de abrirlo
      var sections = res.body.sections || {};
      if (sections['cart-drawer'] && cd) {
        try {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var newCD = doc.querySelector('cart-drawer');
          if (newCD) {
            cd.classList.add('cd-skip-anim');
            cd.innerHTML = newCD.innerHTML;
            cd.classList.remove('is-empty');
            var ov = cd.querySelector('#CartDrawer-Overlay');
            if (ov && cd.close) ov.addEventListener('click', function(){ try{ cd.close(); }catch(e){} });
          }
        } catch(e) { console.warn('sticky drawer inject failed', e); }
      }
      if (sections['cart-icon-bubble']) {
        var ib = document.getElementById('cart-icon-bubble');
        if (ib) {
          try {
            var bDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var ni = bDoc.querySelector('.shopify-section');
            if (ni) ib.innerHTML = ni.innerHTML;
          } catch(e) { console.warn('sticky bubble inject failed', e); }
        }
      }

      // AHORA abrimos el drawer — estado correcto (sin duplicados visibles)
      if (cd) {
        try { cd.open(btn); } catch(e){}
      }

      if (txt) txt.textContent = '¡Añadido!';

      // Restaurar texto sticky cuando drawer se cierre
      var restored = false;
      var restoreSticky = function(){
        if (restored) return;
        restored = true;
        if (txt) txt.textContent = originalText;
      };
      var safetyT;
      if (cd) {
        var everActive = cd.classList.contains('active');
        var obs = new MutationObserver(function(){
          var isActive = cd.classList.contains('active');
          if (isActive) everActive = true;
          if (everActive && !isActive) {
            restoreSticky();
            obs.disconnect();
            clearTimeout(safetyT);
          }
        });
        obs.observe(cd, {attributes:true, attributeFilter:['class']});
        safetyT = setTimeout(function(){ obs.disconnect(); restoreSticky(); }, 8000);
      } else {
        setTimeout(restoreSticky, 1800);
      }

      // Update gift bar/availability after cart change
      try {
        fetch('/cart.js', {credentials:'same-origin', cache:'no-store'})
          .then(function(r){ return r.json(); })
          .then(function(cart){
            if (window.cgbUpdateAvailability) window.cgbUpdateAvailability(cart);
          })
          .catch(function(){});
      } catch(e){}
    })
    .catch(function(e){
      console.error('sticky ATC error', e);
      if (txt) txt.textContent = 'Error';
      setTimeout(function(){ if (txt) txt.textContent = originalText; }, 2500);
    })
    .finally(function(){
      btn.classList.remove('is-loading');
    });
  }

  function openSheet() {
    var sheet = document.getElementById('sticky-variant-sheet');
    if (!sheet) return;
    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeSheet() {
    var sheet = document.getElementById('sticky-variant-sheet');
    if (!sheet) return;
    sheet.hidden = true;
    document.body.style.overflow = '';
  }

  function selectVariant(variantId) {
    var btn = document.getElementById('sticky-atc-btn');
    var buyNow = document.getElementById('sticky-buynow-btn');
    if (btn) btn.setAttribute('data-variant-id', variantId);
    if (buyNow) buyNow.setAttribute('data-variant-id', variantId);

    var sheet = document.getElementById('sticky-variant-sheet');
    var label = document.getElementById('sticky-variant-label');
    var matchedTitle = null;
    var matchedAvailable = true;
    if (sheet) {
      sheet.querySelectorAll('.sticky-variant-option').forEach(function(opt){
        var sel = opt.getAttribute('data-variant-id') === String(variantId);
        opt.classList.toggle('is-selected', sel);
        opt.setAttribute('aria-selected', sel ? 'true' : 'false');
        if (sel) {
          matchedTitle = opt.getAttribute('data-variant-title');
          matchedAvailable = opt.getAttribute('data-variant-available') === 'true';
        }
      });
    }
    if (label && matchedTitle) label.textContent = matchedTitle;

    if (btn) {
      var txt = btn.querySelector('.sticky-mirror-btn-text');
      if (!matchedAvailable) {
        btn.setAttribute('data-soldout', 'true');
        if (txt) txt.textContent = 'AGOTADO';
        // NO tocar buyNow — el sheet maneja la selección de variant
      } else {
        btn.removeAttribute('data-soldout');
        if (txt && txt.textContent === 'AGOTADO') txt.textContent = 'AÑADIR';
        if (buyNow) buyNow.removeAttribute('data-soldout');
      }
    }
  }

  /* ============================================
     BUY NOW SHEET (Temu-style) — opciones + qty + checkout
     ============================================ */
  var BNS = {
    variants: null,
    selectedOptions: [],
    selectedVariant: null,
    qty: 1,
    init: function(){
      if (this.variants) return;
      var dataEl = document.getElementById('sticky-buynow-variants-data');
      if (!dataEl) return;
      try { this.variants = JSON.parse(dataEl.textContent); } catch(e){ this.variants = []; }
      // Inicializa selección con la primera variante disponible (o la actual del form)
      var currentId = getCurrentVariantId();
      var current = this.variants.find(function(v){ return String(v.id) === String(currentId); }) || this.variants[0];
      if (current){
        this.selectedOptions = current.options ? current.options.slice() : [current.option1, current.option2, current.option3].filter(Boolean);
        this.selectedVariant = current;
      }
      // Marca botones según selección
      this.applyUI();
    },
    findVariant: function(opts){
      return this.variants.find(function(v){
        var vOpts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        for (var i=0; i<opts.length; i++){
          if (vOpts[i] !== opts[i]) return false;
        }
        return true;
      });
    },
    selectOption: function(pos, value){
      // pos es 1-indexed
      var idx = pos - 1;
      while (this.selectedOptions.length <= idx) this.selectedOptions.push('');
      this.selectedOptions[idx] = value;
      // Buscar variant matching
      var v = this.findVariant(this.selectedOptions);
      if (v) this.selectedVariant = v;
      this.applyUI();
    },
    applyUI: function(){
      var sheet = document.getElementById('sticky-buynow-sheet');
      if (!sheet) return;
      // Update button selected states
      sheet.querySelectorAll('.sticky-buynow-option-value').forEach(function(btn){
        var pos = parseInt(btn.getAttribute('data-option-position'), 10);
        var val = btn.getAttribute('data-option-value');
        btn.classList.toggle('is-selected', BNS.selectedOptions[pos-1] === val);
      });
      // Update labels
      sheet.querySelectorAll('[data-option-selected]').forEach(function(span){
        var pos = parseInt(span.getAttribute('data-option-selected'), 10);
        span.textContent = BNS.selectedOptions[pos-1] || '';
      });
      // Update photo if variant has featured_image
      var photo = document.getElementById('sticky-buynow-photo');
      if (photo && BNS.selectedVariant && BNS.selectedVariant.featured_image && BNS.selectedVariant.featured_image.src){
        var src = BNS.selectedVariant.featured_image.src;
        if (src.indexOf('//') === 0) src = 'https:' + src;
        if (src.indexOf('?') === -1) src = src + '?width=800';
        else if (src.indexOf('width=') === -1) src = src + '&width=800';
        photo.src = src;
      }
      // Update price
      var priceEl = document.getElementById('sticky-buynow-price');
      var compareEl = document.getElementById('sticky-buynow-compare');
      if (BNS.selectedVariant && priceEl){
        priceEl.textContent = BNS.formatMoney(BNS.selectedVariant.price);
        if (compareEl){
          if (BNS.selectedVariant.compare_at_price && BNS.selectedVariant.compare_at_price > BNS.selectedVariant.price){
            compareEl.textContent = BNS.formatMoney(BNS.selectedVariant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
      }
      // Confirm button availability
      var confirmBtn = document.getElementById('sticky-buynow-confirm');
      if (confirmBtn){
        if (BNS.selectedVariant && BNS.selectedVariant.available){
          confirmBtn.disabled = false;
          confirmBtn.textContent = 'ACHETER MAINTENANT';
        } else {
          confirmBtn.disabled = true;
          confirmBtn.textContent = 'AGOTADO';
        }
      }
      // Qty value
      var qtyEl = document.getElementById('sticky-buynow-qty-value');
      if (qtyEl) qtyEl.textContent = BNS.qty;
    },
    formatMoney: function(cents){
      // Respect active shop currency via WAB_CURRENCY
      var c = window.WAB_CURRENCY || {};
      var s = (cents/100).toFixed(2);
      if (c.useComma) s = s.replace('.', ',');
      if (c.prefix || c.suffix) return (c.prefix || '') + s + (c.suffix || '');
      return '$ ' + s;
    },
    _scrollY: 0,
    _touchBound: false,
    open: function(){
      this.init();
      var sheet = document.getElementById('sticky-buynow-sheet');
      if (!sheet) return;
      sheet.hidden = false;
      // iOS scroll lock: position:fixed + top:-scrollY
      this._scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.bnLockY = String(this._scrollY);
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + this._scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.body.classList.add('bn-sheet-open');
      // Bloquea touchmove fuera del sheet body
      if (!this._touchBound){
        this._touchBound = true;
        sheet.addEventListener('touchmove', function(e){
          var body = sheet.querySelector('.sticky-buynow-sheet-body');
          if (!body || !body.contains(e.target)) e.preventDefault();
        }, { passive: false });
      }
    },
    close: function(){
      var sheet = document.getElementById('sticky-buynow-sheet');
      if (!sheet) return;
      sheet.hidden = true;
      var y = parseInt(document.body.dataset.bnLockY || '0', 10);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.classList.remove('bn-sheet-open');
      delete document.body.dataset.bnLockY;
      window.scrollTo(0, y);
      // FIX: re-sync estado del botón sticky buy-now ANTES y DESPUÉS de cerrar
      // (evita que data-soldout residual bloquee el siguiente click)
      var resetStickyBuyNow = function(){
        var stickyBuy = document.getElementById('sticky-buynow-btn');
        if (!stickyBuy) return;
        var fs = document.querySelector('fieldset.product-form__input--pill');
        var sizeOk = !fs || !!fs.querySelector('input[type=radio]:checked');
        var atc = document.querySelector('.product-form__submit');
        var available = !(atc && (atc.disabled || atc.getAttribute('aria-disabled') === 'true'));
        if (sizeOk && available){
          stickyBuy.removeAttribute('data-soldout');
          stickyBuy.classList.remove('is-loading');
        }
      };
      resetStickyBuyNow();                    // inmediato
      setTimeout(resetStickyBuyNow, 50);      // tras micro-tasks
      setTimeout(resetStickyBuyNow, 200);     // tras restoreScroll
      setTimeout(resetStickyBuyNow, 500);     // tras cualquier observer
    },
    confirm: function(){
      if (!this.selectedVariant || !this.selectedVariant.available) return;
      var btn = document.getElementById('sticky-buynow-confirm');
      if (btn){ btn.classList.add('is-loading'); btn.textContent = 'CHARGEMENT...'; }
      var variantId = this.selectedVariant.id;
      var qty = this.qty;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
      })
      .then(function(r){ return r.json().then(function(j){ return {status:r.status, body:j}; }); })
      .then(function(res){
        if (res.status >= 400){
          if (btn){ btn.classList.remove('is-loading'); btn.textContent = (res.body && res.body.description) || 'ERREUR'; }
          setTimeout(function(){ if (btn) btn.textContent = 'ACHETER MAINTENANT'; }, 2500);
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function(e){
        console.error('buy now confirm error', e);
        if (btn){ btn.classList.remove('is-loading'); btn.textContent = 'ERREUR'; setTimeout(function(){ btn.textContent = 'ACHETER MAINTENANT'; }, 2500); }
      });
    }
  };

  function stickyBuyNow() {
    var btn = document.getElementById('sticky-buynow-btn');
    if (!btn) return;
    // Limpia state residual y abre el sheet — el sheet maneja la lógica de variants
    btn.removeAttribute('data-soldout');
    btn.classList.remove('is-loading');
    closeSheet();
    BNS.open();
  }

  document.addEventListener('click', function(e) {
    var atc = e.target.closest('#sticky-atc-btn');
    if (atc) {
      e.preventDefault();
      stickyAddToCart();
      return;
    }
    var buyNow = e.target.closest('#sticky-buynow-btn');
    if (buyNow) {
      e.preventDefault();
      stickyBuyNow();
      return;
    }
    var toggle = e.target.closest('#sticky-variant-toggle');
    if (toggle) {
      e.preventDefault();
      openSheet();
      return;
    }
    if (e.target.closest('[data-sticky-sheet-close]')) {
      e.preventDefault();
      closeSheet();
      return;
    }
    var optBtn = e.target.closest('.sticky-variant-option');
    if (optBtn && !optBtn.classList.contains('is-unavailable')) {
      e.preventDefault();
      var vid = optBtn.getAttribute('data-variant-id');
      selectVariant(vid);
      return;
    }
    // Buy Now sheet handlers
    if (e.target.closest('[data-buynow-sheet-close]')){
      e.preventDefault();
      BNS.close();
      return;
    }
    var bnOpt = e.target.closest('.sticky-buynow-option-value');
    if (bnOpt){
      e.preventDefault();
      var pos = parseInt(bnOpt.getAttribute('data-option-position'), 10);
      var val = bnOpt.getAttribute('data-option-value');
      BNS.selectOption(pos, val);
      return;
    }
    var qtyBtn = e.target.closest('[data-buynow-qty]');
    if (qtyBtn){
      e.preventDefault();
      var act = qtyBtn.getAttribute('data-buynow-qty');
      if (act === 'inc') BNS.qty = Math.min(99, BNS.qty + 1);
      else if (act === 'dec') BNS.qty = Math.max(1, BNS.qty - 1);
      BNS.applyUI();
      return;
    }
    if (e.target.closest('#sticky-buynow-confirm')){
      e.preventDefault();
      BNS.confirm();
      return;
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      var sheet = document.getElementById('sticky-buynow-sheet');
      if (sheet && !sheet.hidden) BNS.close();
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.closest('product-info, .product-form__input, variant-selects, variant-radios')) {
      setTimeout(syncStickyFromForm, 50);
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(syncStickyFromForm, 200);
  });
})();
/* ============================================
   CAMBIO DE IMÁGENES AL SELECCIONAR VARIANTE
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {
  function initVariantImageSwitch() {
    const swatchInputs = document.querySelectorAll('.swatch-input__input');

    swatchInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        const variantImage = this.dataset.variantImage;
        if (!variantImage) return;

        const productSection = this.closest('.product');
        if (!productSection) return;

        const sectionId = productSection
          .querySelector('media-gallery')
          ?.id?.replace('MediaGallery-', '');
        if (!sectionId) return;

        const mediaGallery = document.getElementById('MediaGallery-' + sectionId);
        if (!mediaGallery) return;

        const variantImageBase = variantImage
          .split('?')[0]
          .split('/')
          .pop()
          .replace(/(_\d+x\d*|_\d*x\d+|_crop_\w+)*\.\w+$/, '');

        const allSlides = mediaGallery.querySelectorAll('.product__media-item');
        let targetMediaId = null;

        allSlides.forEach(function (slide) {
          const img = slide.querySelector('img');
          if (!img) return;

          const imgSrc = img.src || img.currentSrc || '';
          const imgBase = imgSrc
            .split('?')[0]
            .split('/')
            .pop()
            .replace(/(_\d+x\d*|_\d*x\d+|_crop_\w+)*\.\w+$/, '');

          if (imgBase === variantImageBase) {
            targetMediaId = slide.dataset.mediaId;
          }
        });

        if (!targetMediaId) return;

        const targetThumbnail = mediaGallery.querySelector(
          '[data-target="' + targetMediaId + '"]'
        );

        if (targetThumbnail) {
          const thumbnailButton = targetThumbnail.querySelector('button');
          if (thumbnailButton) thumbnailButton.click();
        } else {
          const targetSlide = mediaGallery.querySelector(
            '[data-media-id="' + targetMediaId + '"]'
          );
          if (targetSlide) {
            allSlides.forEach(el => el.classList.remove('is-active'));
            targetSlide.classList.add('is-active');
          }
        }
      });
    });
  }

  initVariantImageSwitch();
});
